import { useState, useEffect } from 'react';
import axios from 'axios';
import Header from './Header';
import Footer from './Footer';

const Books = () => {
  const server_app_api_php = window.SERVER_APP_API_PHP;

  const [activeSection, setActiveSection] = useState('Adventurers');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedBook, setSelectedBook] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [viewMode, setViewMode] = useState('preview');
  const [iframeLoading, setIframeLoading] = useState(true);

  const sections = [
    { id: 'Adventurers', title: 'Adventurers', color: 'from-pink-500 to-rose-500', icon: '' },
    { id: 'Pathfinders', title: 'Pathfinders', color: 'from-green-500 to-emerald-500', icon: '' },
    { id: 'Ambassadors', title: 'Ambassadors', color: 'from-blue-500 to-cyan-500', icon: '' },
    { id: 'PCM', title: 'PCM', color: 'from-purple-500 to-indigo-500', icon: '' },
    { id: 'Young-Adults', title: 'Young Adults', color: 'from-amber-500 to-orange-500', icon: '' },
    { id: 'Master-Guides', title: 'Master Guides', color: 'from-red-500 to-pink-500', icon: '' },
    { id: 'SYL', title: 'SYL', color: 'from-indigo-500 to-purple-500', icon: '' },
    { id: 'CMT', title: 'CMT', color: 'from-emerald-500 to-green-500', icon: '' }
  ];

  const bookCategories = {
    'Adventurers': [
      { title: "Adventurer Director's Manual", image: "Adventurer Directors Manual image.jpg", file: "Adventurer Directors Manual.pdf" },
      { title: "Adventurer Award Book", image: "Award Book 2020 image.jpg", file: "Award Book 2020.pdf" },
      { title: "Little Lamb", image: "little lamb image.jpg", file: "Little Lamb.pdf" },
      { title: "Early Bird", image: "early bird image.jpg", file: "Early Bird.pdf" },
      { title: "Busy Bee", image: "busy bee image.jpg", file: "Busy Bee.pdf" },
      { title: "Sun Beam", image: "sun beam image.jpg", file: "Sun Beam.pdf" },
      { title: "Builder", image: "builder image.jpg", file: "Builder.pdf" },
      { title: "Helping Hands", image: "helping hands image.jpg", file: "Helping Hands.pdf" }
    ],
    'Pathfinders': [
      { title: "Friend Manual", image: "friend manual image.jpg", file: "Friend Manual.pdf" },
      { title: "Companion Manual", image: "companion manual image.jpg", file: "Companion Manual.pdf" },
      { title: "Explorer Manual", image: "explorer manual image.jpg", file: "Explorer Manual.pdf" },
      { title: "Ranger Manual", image: "ranger manual image.jpg", file: "Ranger Manual.pdf" },
      { title: "Voyager Manual", image: "voyager manual image.jpg", file: "Voyager Manual.pdf" },
      { title: "Guide Manual", image: "guide manual image.jpg", file: "Guide Manual.pdf" }
    ],
    'Ambassadors': [
      { title: "Ambassador Administrative Manual", image: "Ambassadors Administrative Manual.jpg", file: "Ambassadors Administrative Manual.pdf" },
      { title: "Module 1 (Leader)", image: "Module 1 Leader.jpg", file: "Module 1 Leader.pdf" },
      { title: "Module 1 (Participant)", image: "Module 1 Participant.jpg", file: "Module 1 Participant.pdf" },
      { title: "Module 2 (Leader)", image: "Module 2 Leader.jpg", file: "Module 2 Leader.pdf" }
    ],
    'PCM': [
      { title: "PCM Manual", image: "PCM Manual.jpg", file: "PCM Manual.pdf" },
      { title: "PCM Student Handbook", image: "PCM Student Handbook.jpg", file: "PCM Student Handbook.pdf" }
    ],
    'Young-Adults': [
      { title: "Senior Youth Manual", image: "Young Adults Manual.jpg", file: "Young Adults Manual.pdf" },
      { title: "AY Story", image: "AY Story.jpg", file: "AY Story.pdf" },
      { title: "Mentoring in Ministry", image: "Incorporating Mentoring in Your Ministry.jpg", file: "Incorporating Mentoring in Your Ministry.pdf" }
    ],
    'Master-Guides': [
      { title: "MG Curriculum Manual", image: "MG-curriculum-manual.jpg", file: "MG-curriculum-manual.pdf" },
      { title: "MG Workshop Resources", image: "MG 22 Appendix Workshop Resources.jpg", file: "MG 22 Appendix Workshop Resources.pdf" }
    ],
    'SYL': [
      { title: "Seminar 1 Introduction", image: "Seminar 1 Introduction.jpg", file: "Seminar 1 Introduction.pptx" },
      { title: "Seminar 2 Youth Development", image: "Seminar 2 Youth Development.jpg", file: "Seminar 2 Youth Development.pptx" },
      { title: "Seminar 3 Specialized Ministry", image: "Seminar 3 Need for specialized ministry.jpg", file: "Seminar 3 Need for specialized ministry.pptx" }
    ],
    'CMT': [
      { title: "CMT Manual", image: "CMT 2022.jpg", file: "CMT 2022.pdf" },
      { title: "CMT Requirements Card", image: "WC CMT REQUIREMENT CARD 2023.jpg", file: "WC CMT REQUIREMENT CARD 2023.pdf" }
    ]
  };

  // DEBUG: Added logging to track PDF URL generation
  const getPdfViewUrl = (category, filename) => {
    let path = '';
    switch(category) {
      case 'Adventurers': path = `materials/adventurers/books/${filename}`; break;
      case 'Pathfinders': path = `materials/pathfinders/books/${filename}`; break;
      case 'Ambassadors': path = `materials/ambassadors/books/${filename}`; break;
      case 'PCM': path = `materials/pcm/books/${filename}`; break;
      case 'Young-Adults': path = `materials/young adults/books/${filename}`; break;
      case 'Master-Guides': path = `materials/mg/books/${filename}`; break;
      case 'SYL': path = `materials/syl/books/${filename}`; break;
      case 'CMT': path = `materials/cmt/books/${filename}`; break;
    }
    
    // Log the path for debugging
    console.log('DEBUG getPdfViewUrl - Raw path:', path);
    
    // Construct the full URL
    const fullUrl = server_app_api_php + '/resources/' + path;
    
    // Log the full URL
    console.log('DEBUG getPdfViewUrl - Full URL:', fullUrl);
    console.log('DEBUG getPdfViewUrl - Category:', category);
    console.log('DEBUG getPdfViewUrl - Filename:', filename);
    
    return fullUrl;
  };

  // Keep separate function for downloads
  const getDownloadUrl = (category, filename) => {
    let path = '';
    switch(category) {
      case 'Adventurers': path = `materials/adventurers/books/${filename}`; break;
      case 'Pathfinders': path = `materials/pathfinders/books/${filename}`; break;
      case 'Ambassadors': path = `materials/ambassadors/books/${filename}`; break;
      case 'PCM': path = `materials/pcm/books/${filename}`; break;
      case 'Young-Adults': path = `materials/young adults/books/${filename}`; break;
      case 'Master-Guides': path = `materials/mg/books/${filename}`; break;
      case 'SYL': path = `materials/syl/books/${filename}`; break;
      case 'CMT': path = `materials/cmt/books/${filename}`; break;
    }
    return server_app_api_php + '/resources/downloadAYMaterials.php?file=' + path;
  };

  const openModal = (book) => {
    console.log('DEBUG openModal - Book selected:', book);
    console.log('DEBUG openModal - Active section:', activeSection);
    
    // Log the view URL before setting state
    const viewUrl = getPdfViewUrl(activeSection, book.file);
    console.log('DEBUG openModal - View URL to be used:', viewUrl);
    
    setSelectedBook(book);
    setIsModalOpen(true);
    setViewMode('preview');
    setIframeLoading(true);
    document.body.style.overflow = 'hidden';
    
    // Log after state is set (use timeout to ensure state is updated)
    setTimeout(() => {
      console.log('DEBUG openModal - Modal opened for book:', selectedBook);
    }, 100);
  };

  const closeModal = () => {
    console.log('DEBUG closeModal - Closing modal');
    setIsModalOpen(false);
    setSelectedBook(null);
    setIframeLoading(false);
    document.body.style.overflow = 'auto';
  };

  const toggleViewMode = () => {
    console.log('DEBUG toggleViewMode - Switching from', viewMode, 'to', viewMode === 'preview' ? 'full' : 'preview');
    setViewMode(prev => prev === 'preview' ? 'full' : 'preview');
  };

  const downloadBook = async (category, filename) => {
    console.log('DEBUG downloadBook - Starting download for:', filename);
    console.log('DEBUG downloadBook - Category:', category);
    
    setIsLoading(true);
    try {
      const url = getDownloadUrl(category, filename);
      console.log('DEBUG downloadBook - Download URL:', url);
      
      const response = await axios.get(url, {
        responseType: 'blob'
      });
      
      console.log('DEBUG downloadBook - Response status:', response.status);
      console.log('DEBUG downloadBook - Response headers:', response.headers);
      
      if (response.status === 200) {
        const blob = new Blob([response.data], { type: 'application/octet-stream' });
        const downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(blob);
        downloadLink.download = filename;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
        
        showNotification('Download started successfully!');
        console.log('DEBUG downloadBook - Download initiated successfully');
      }
    } catch (error) {
      console.error('DEBUG downloadBook - Error:', error);
      console.error('DEBUG downloadBook - Error response:', error.response);
      showNotification('Error downloading file. Please try again.', 'error');
    } finally {
      setIsLoading(false);
    }
  };

  const showNotification = (message, type = 'success') => {
    console.log('DEBUG showNotification - Showing:', message, 'Type:', type);
    const notification = document.createElement('div');
    notification.className = `fixed top-4 right-4 z-50 px-6 py-3 rounded-lg shadow-xl transform transition-all duration-300 translate-x-full ${
      type === 'success' ? 'bg-gradient-to-r from-green-500 to-emerald-500' : 'bg-gradient-to-r from-red-500 to-pink-500'
    } text-white`;
    notification.textContent = message;
    
    document.body.appendChild(notification);
    
    setTimeout(() => {
      notification.classList.remove('translate-x-full');
      notification.classList.add('translate-x-0');
    }, 10);
    
    setTimeout(() => {
      notification.classList.remove('translate-x-0');
      notification.classList.add('translate-x-full');
      setTimeout(() => {
        document.body.removeChild(notification);
      }, 300);
    }, 3000);
  };

  const filteredBooks = bookCategories[activeSection]?.filter(book =>
    book.title.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Close modal on ESC key
  useEffect(() => {
    const handleEscKey = (e) => {
      if (e.key === 'Escape' && isModalOpen) {
        closeModal();
      }
    };
    
    window.addEventListener('keydown', handleEscKey);
    return () => window.removeEventListener('keydown', handleEscKey);
  }, [isModalOpen]);

  const currentSection = sections.find(s => s.id === activeSection);

  // Debug effect to log when selectedBook changes
  useEffect(() => {
    if (selectedBook) {
      console.log('DEBUG useEffect - selectedBook updated:', selectedBook);
      console.log('DEBUG useEffect - activeSection:', activeSection);
      
      // Log the view URL
      const viewUrl = getPdfViewUrl(activeSection, selectedBook.file);
      console.log('DEBUG useEffect - Calculated view URL:', viewUrl);
    }
  }, [selectedBook, activeSection]);

  return (
    <>
      <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-blue-50/30">
        <Header />
        
        {/* Hero Section */}
        <div className="relative pt-24 pb-16 overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-r from-blue-600/20 via-purple-600/20 to-pink-600/20"></div>
          <div className="relative max-w-7xl mx-auto px-4">
            <div className="text-center mb-8">
              <h1 className="text-5xl md:text-7xl font-bold mb-6 bg-clip-text text-transparent bg-gradient-to-r from-blue-600 to-purple-600">
                Ministry Resources
              </h1>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                Access, read online, and download educational materials for all Adventist Youth Ministries. 
                Browse by ministry type to find relevant resources.
              </p>
            </div>
          </div>
        </div>

        <main className="pb-20">
          <div className="max-w-7xl mx-auto px-4">
            {/* Search Bar */}
            <div className="mb-12">
              <div className="relative max-w-2xl mx-auto">
                <div className="absolute inset-y-0 left-4 flex items-center pointer-events-none">
                  <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                  </svg>
                </div>
                <input
                  type="text"
                  placeholder="Search books by title..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="w-full pl-12 pr-4 py-4 bg-white/80 backdrop-blur-sm border-0 rounded-2xl shadow-xl focus:ring-2 focus:ring-blue-500 focus:outline-none text-lg"
                />
                {searchTerm && (
                  <button
                    onClick={() => setSearchTerm('')}
                    className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
                  >
                    ✕
                  </button>
                )}
              </div>
            </div>

            {/* Navigation Tabs */}
            <nav className="mb-16">
              <div className="flex flex-wrap gap-3 justify-center">
                {sections.map((section) => (
                  <button
                    key={section.id}
                    onClick={() => setActiveSection(section.id)}
                    className={`group relative flex items-center gap-3 px-6 py-4 rounded-2xl font-semibold transform transition-all duration-300 shadow-lg ${
                      activeSection === section.id 
                        ? `bg-gradient-to-r ${section.color} text-white scale-105`
                        : 'bg-white text-gray-700 hover:bg-gray-50'
                    }`}
                  >
                    <span className="text-xl">{section.icon}</span>
                    <span>{section.title}</span>
                    {activeSection === section.id && (
                      <div className="absolute -bottom-2 left-1/2 transform -translate-x-1/2 w-16 h-1 bg-white rounded-full"></div>
                    )}
                  </button>
                ))}
              </div>
            </nav>

            {/* Active Section Content */}
            <div className="mb-20">
              <div className="text-center mb-12">
                <div className={`inline-flex items-center justify-center gap-4 bg-gradient-to-r ${currentSection.color} text-white px-8 py-4 rounded-2xl mb-6 shadow-xl`}>
                  <span className="text-3xl">{currentSection.icon}</span>
                  <h2 className="text-4xl font-bold">{currentSection.title} MINISTRY</h2>
                </div>
                <p className="text-gray-600 max-w-2xl mx-auto text-lg">
                  {filteredBooks?.length || 0} resources available for {currentSection.title.toLowerCase()} ministry.
                </p>
              </div>

              {/* Books Grid */}
              <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
                {filteredBooks?.map((book, idx) => (
                  <div 
                    key={idx} 
                    className="group relative bg-white/90 backdrop-blur-sm rounded-3xl shadow-2xl overflow-hidden transform hover:-translate-y-2 transition-all duration-500 hover:shadow-3xl cursor-pointer"
                    onClick={() => openModal(book)}
                  >
                    {/* Glow Effect */}
                    <div className="absolute -inset-1 bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 rounded-3xl blur opacity-0 group-hover:opacity-20 transition duration-500"></div>
                    
                    <div className="relative">
                      {/* Book Cover */}
                      <div className="relative h-56 overflow-hidden">
                        <img 
                          src={`${server_app_api_php}/resources/materials/${activeSection.toLowerCase()}/images/${book.image}`}
                          alt={book.title}
                          className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
                          onError={(e) => {
                            e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(book.title)}&background=random&color=fff&size=400`;
                          }}
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                        
                        {/* Quick Actions */}
                        <div className="absolute top-4 right-4 flex gap-2 opacity-0 group-hover:opacity-100 transition-all duration-300 transform translate-y-2 group-hover:translate-y-0">
                          {book.file.toLowerCase().endsWith('.pdf') && (
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                openModal(book);
                              }}
                              className="bg-blue-500/90 hover:bg-blue-600 text-white w-12 h-12 rounded-full flex items-center justify-center shadow-lg transform hover:scale-110 transition-all duration-300"
                              title="Read Online"
                            >
                              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                                <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/>
                              </svg>
                            </button>
                          )}
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              downloadBook(activeSection, book.file);
                            }}
                            className="bg-white/90 hover:bg-white text-gray-800 w-12 h-12 rounded-full flex items-center justify-center shadow-lg transform hover:scale-110 transition-all duration-300"
                            title="Download"
                          >
                            {isLoading ? (
                              <div className="w-5 h-5 border-2 border-gray-800 border-t-transparent rounded-full animate-spin"></div>
                            ) : (
                              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                                <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"/>
                              </svg>
                            )}
                          </button>
                        </div>
                        
                        {/* Book Type Badge */}
                        <div className="absolute bottom-4 left-4 flex gap-2">
                          <span className="bg-black/60 backdrop-blur-sm text-white px-3 py-1 rounded-full text-xs font-semibold">
                            {book.file.split('.').pop().toUpperCase()}
                          </span>
                          {book.file.toLowerCase().endsWith('.pdf') && (
                            <span className="bg-blue-500/90 backdrop-blur-sm text-white px-3 py-1 rounded-full text-xs font-semibold flex items-center gap-1">
                              <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 24 24">
                                <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/>
                              </svg>
                              Read Online
                            </span>
                          )}
                        </div>
                      </div>
                      
                      {/* Book Info */}
                      <div className="p-6">
                        <h3 className="font-bold text-gray-800 text-lg mb-3 line-clamp-2 group-hover:text-transparent group-hover:bg-clip-text group-hover:bg-gradient-to-r group-hover:from-blue-600 group-hover:to-purple-600 transition-all duration-300">
                          {book.title}
                        </h3>
                        
                        <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                          <span className="text-sm text-gray-500 flex items-center gap-2" hidden>
                            <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                            </svg>
                            Free Resource
                          </span>
                          <div className="flex gap-2">
                            {book.file.toLowerCase().endsWith('.pdf') && (
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  openModal(book);
                                }}
                                className="bg-gradient-to-r from-blue-500 to-cyan-500 text-white px-4 py-2 rounded-xl hover:shadow-lg transform hover:scale-105 transition-all duration-300 flex items-center gap-2"
                              >
                                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                                  <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/>
                                </svg>
                                <span>Read</span>
                              </button>
                            )}
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                downloadBook(activeSection, book.file);
                              }}
                              className={`bg-gradient-to-r ${currentSection.color} text-white px-4 py-2 rounded-xl hover:shadow-lg transform hover:scale-105 transition-all duration-300 flex items-center gap-2`}
                            >
                              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                                <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"/>
                              </svg>
                              <span>Download</span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Empty State */}
              {(!filteredBooks || filteredBooks.length === 0) && (
                <div className="text-center py-20">
                  <div className="relative w-32 h-32 mx-auto mb-8">
                    <div className="absolute inset-0 bg-gradient-to-r from-gray-200 to-gray-300 rounded-full animate-pulse"></div>
                    <div className="relative w-full h-full bg-gradient-to-r from-blue-100 to-purple-100 rounded-full flex items-center justify-center">
                      <svg className="w-16 h-16 text-gray-400" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"/>
                      </svg>
                    </div>
                  </div>
                  <h3 className="text-2xl font-semibold text-gray-700 mb-4">No Resources Found</h3>
                  <p className="text-gray-500 max-w-md mx-auto">
                    {searchTerm ? `No books found for "${searchTerm}". Try a different search term.` : 'Check back soon for new resources.'}
                  </p>
                  {searchTerm && (
                    <button
                      onClick={() => setSearchTerm('')}
                      className="mt-6 bg-gradient-to-r from-blue-500 to-purple-500 text-white px-6 py-3 rounded-xl hover:shadow-lg transform hover:scale-105 transition-all duration-300"
                    >
                      Clear Search
                    </button>
                  )}
                </div>
              )}
            </div>

            {/* Stats Section */}
            <div className="bg-gradient-to-r from-blue-600 via-purple-600 to-pink-600 rounded-3xl p-8 mb-20 shadow-2xl transform hover:scale-[1.02] transition-transform duration-300" hidden>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
                {[
                  { label: 'PDF Resources', value: '35+', icon: '📄' },
                  { label: 'Read Online', value: 'Yes', icon: '👁️' },
                  { label: 'Free Access', value: '100%', icon: '🎁' },
                  { label: 'Updated', value: '2024', icon: '🔄' }
                ].map((stat, idx) => (
                  <div key={idx} className="text-center group">
                    <div className="text-4xl mb-3 group-hover:scale-110 transition-transform duration-300">{stat.icon}</div>
                    <div className="text-4xl font-bold text-white mb-2">{stat.value}</div>
                    <div className="text-blue-100 text-sm font-medium">{stat.label}</div>
                  </div>
                ))}
              </div>
            </div>

            {/* Help Section */}
            <div className="relative bg-gradient-to-br from-white to-gray-50 rounded-3xl shadow-2xl p-8 overflow-hidden" hidden>
              <div className="absolute top-0 right-0 w-64 h-64 bg-gradient-to-br from-blue-500/10 to-purple-500/10 rounded-full -translate-y-32 translate-x-32"></div>
              
              <div className="relative text-center mb-8">
                <h3 className="text-3xl font-bold text-gray-800 mb-4">Need Assistance?</h3>
                <p className="text-gray-600 max-w-2xl mx-auto">
                  Having trouble accessing or reading materials? Our support team is here to help you get the resources you need.
                </p>
              </div>
              
              <div className="flex flex-wrap gap-4 justify-center">
                <a href="mailto:support@wcay.org" className="group relative bg-gradient-to-r from-blue-500 to-cyan-500 text-white px-8 py-4 rounded-xl hover:shadow-2xl transform hover:scale-105 transition-all duration-300 overflow-hidden">
                  <div className="absolute inset-0 bg-gradient-to-r from-blue-600 to-cyan-600 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  <div className="relative flex items-center justify-center gap-3">
                    <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
                    </svg>
                    <span className="font-semibold">Email Support</span>
                  </div>
                </a>
                
                <a href="tel:+1234567890" className="group relative bg-white border-2 border-blue-500 text-blue-600 px-8 py-4 rounded-xl hover:bg-blue-50 hover:shadow-xl transform hover:scale-105 transition-all duration-300">
                  <div className="flex items-center justify-center gap-3">
                    <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
                    </svg>
                    <span className="font-semibold">Call Support</span>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </main>

        <Footer />

        {/* PDF Viewer Modal */}
        {isModalOpen && selectedBook && (
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
            {/* Backdrop */}
            <div 
              className="absolute inset-0 bg-black/80 backdrop-blur-sm"
              onClick={closeModal}
            ></div>
            
            {/* Modal Content */}
            <div className={`relative w-full ${viewMode === 'full' ? 'max-w-7xl h-5/6' : 'max-w-6xl'} bg-white rounded-3xl shadow-2xl overflow-hidden transform transition-all duration-500 scale-100 opacity-100 flex flex-col`}>
              {/* Modal Header */}
              <div className="relative p-6 border-b border-gray-100 flex-shrink-0">
                <div className="flex items-center justify-between">
                  <div className="flex-1 min-w-0">
                    <h2 className="text-2xl md:text-3xl font-bold text-gray-800 truncate">{selectedBook.title}</h2>
                    <p className="text-gray-600 mt-1 truncate">
                      {currentSection.title} Ministry • {selectedBook.file.split('.').pop().toUpperCase()} File
                    </p>
                  </div>
                  <div className="flex items-center gap-3 ml-4">
                    {selectedBook.file.toLowerCase().endsWith('.pdf') && (
                      <button
                        onClick={toggleViewMode}
                        className="hidden md:flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-blue-500 to-purple-500 text-white rounded-lg hover:shadow-lg transform hover:scale-105 transition-all duration-300"
                      >
                        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                          {viewMode === 'full' ? (
                            <path d="M4 8h4V4H4v4zm6 12h4v-4h-4v4zm-6 0h4v-4H4v4zm0-6h4v-4H4v4zm6 0h4v-4h-4v4zm6-10v4h4V4h-4zm-6 4h4V4h-4v4zm6 6h4v-4h-4v4zm0 6h4v-4h-4v4z"/>
                          ) : (
                            <path d="M21 11V3h-8v3H9V3H3v8h3v4H3v8h8v-3h4v3h8v-8h-3v-4h3zm-10-6h4v4h-4V5zM5 5h4v4H5V5zm0 14v-4h4v4H5zm14 0h-4v-4h4v4zm0-6h-4v-4h4v4z"/>
                          )}
                        </svg>
                        <span>{viewMode === 'full' ? 'Compact View' : 'Full Screen'}</span>
                      </button>
                    )}
                    <button
                      onClick={closeModal}
                      className="w-12 h-12 rounded-full bg-gray-100 hover:bg-gray-200 text-gray-600 hover:text-gray-800 flex items-center justify-center transition-all duration-300 transform hover:scale-110 flex-shrink-0"
                    >
                      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>

              {/* Modal Body */}
              <div className="flex-1 overflow-hidden p-0">
                {selectedBook.file.toLowerCase().endsWith('.pdf') ? (
                  <div className="h-full flex flex-col">
                    {/* PDF Viewer Controls */}
                    <div className="bg-gradient-to-r from-gray-50 to-blue-50 p-4 border-b border-gray-200 flex-shrink-0">
                      <div className="flex flex-wrap items-center justify-between gap-4">
                        <div className="flex items-center gap-4">
                          <div className="text-sm text-gray-600 flex items-center gap-2">
                            <svg className="w-5 h-5 text-green-500" fill="currentColor" viewBox="0 0 24 24">
                              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                            </svg>
                            <span>PDF Ready for Viewing</span>
                          </div>
                        </div>

                        {/* Download Button */}
                        <button
                          onClick={() => {
                            downloadBook(activeSection, selectedBook.file);
                          }}
                          disabled={isLoading}
                          className={`px-6 py-3 bg-gradient-to-r ${currentSection.color} text-white rounded-lg hover:shadow-lg transform hover:scale-105 transition-all duration-300 flex items-center gap-3 disabled:opacity-70`}
                        >
                          {isLoading ? (
                            <>
                              <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                              <span>Downloading...</span>
                            </>
                          ) : (
                            <>
                              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                                <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"/>
                              </svg>
                              <span>Download PDF</span>
                            </>
                          )}
                        </button>
                      </div>
                    </div>

                    {/* PDF Viewer */}
                    <div className="flex-1 overflow-hidden relative">
                      {iframeLoading && (
                        <div className="absolute inset-0 flex items-center justify-center bg-gray-100">
                          <div className="text-center">
                            <div className="w-16 h-16 border-4 border-blue-500 border-t-transparent rounded-full animate-spin mx-auto"></div>
                            <p className="mt-4 text-gray-600 text-lg">Loading PDF document...</p>
                            <p className="text-gray-500 text-sm mt-2">This may take a moment</p>
                          </div>
                        </div>
                      )}
                      
                      {/* DEBUG: Log the iframe source URL */}
                      {(() => {
                        const iframeUrl = getPdfViewUrl(activeSection, selectedBook.file);
                        console.log('DEBUG iframe render - URL being used:', iframeUrl);
                        console.log('DEBUG iframe render - Selected book:', selectedBook);
                        console.log('DEBUG iframe render - Active section:', activeSection);
                        console.log('DEBUG iframe render - Server API base:', server_app_api_php);
                        
                        return (
                          <iframe
                            src={iframeUrl}
                            className="w-full h-full border-0"
                            title={selectedBook.title}
                            onLoad={() => {
                              console.log('DEBUG iframe onLoad - PDF loaded successfully');
                              console.log('DEBUG iframe onLoad - URL:', iframeUrl);
                              setIframeLoading(false);
                            }}
                            onError={(e) => {
                              console.error('DEBUG iframe onError - Failed to load PDF');
                              console.error('DEBUG iframe onError - URL:', iframeUrl);
                              console.error('DEBUG iframe onError - Event:', e);
                              setIframeLoading(false);
                            }}
                            style={{ display: iframeLoading ? 'none' : 'block' }}
                            type="application/pdf"
                          />
                        );
                      })()}
                    </div>
                  </div>
                ) : (
                  <div className="grid md:grid-cols-2 gap-8 p-8">
                    {/* Book Preview */}
                    <div className="relative">
                      <div className="bg-gradient-to-br from-blue-50 to-purple-50 rounded-2xl p-8">
                        <img 
                          src={`${server_app_api_php}/resources/materials/${activeSection.toLowerCase()}/images/${selectedBook.image}`}
                          alt={selectedBook.title}
                          className="w-full h-96 object-contain rounded-xl shadow-lg"
                          onError={(e) => {
                            e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(selectedBook.title)}&background=random&color=fff&size=800`;
                          }}
                        />
                      </div>
                      <div className="absolute -bottom-4 -right-4 w-32 h-32 bg-gradient-to-r from-blue-500/10 to-purple-500/10 rounded-full"></div>
                    </div>

                    {/* Book Details */}
                    <div className="space-y-8">
                      <div>
                        <h3 className="text-xl font-semibold text-gray-800 mb-4">About This Resource</h3>
                        <p className="text-gray-600 leading-relaxed">
                          This educational material is part of the {currentSection.title} Ministry resources collection. 
                          It contains valuable information and guidelines for effective ministry work.
                        </p>
                      </div>

                      <div>
                        <h3 className="text-xl font-semibold text-gray-800 mb-4">File Details</h3>
                        <div className="grid grid-cols-2 gap-4">
                          <div className="bg-gray-50 rounded-xl p-4">
                            <div className="text-sm text-gray-500 mb-1">Format</div>
                            <div className="font-semibold text-gray-800">{selectedBook.file.split('.').pop().toUpperCase()}</div>
                          </div>
                          <div className="bg-gray-50 rounded-xl p-4">
                            <div className="text-sm text-gray-500 mb-1">Ministry</div>
                            <div className="font-semibold text-gray-800">{currentSection.title}</div>
                          </div>
                          <div className="bg-gray-50 rounded-xl p-4">
                            <div className="text-sm text-gray-500 mb-1">Access</div>
                            <div className="font-semibold text-green-600">Free Download</div>
                          </div>
                          <div className="bg-gray-50 rounded-xl p-4">
                            <div className="text-sm text-gray-500 mb-1">Type</div>
                            <div className="font-semibold text-gray-800">Educational Material</div>
                          </div>
                        </div>
                      </div>

                      {/* Action Buttons */}
                      <div className="pt-8 border-t border-gray-100">
                        <div className="flex flex-col sm:flex-row gap-4">
                          <button
                            onClick={() => {
                              downloadBook(activeSection, selectedBook.file);
                              closeModal();
                            }}
                            disabled={isLoading}
                            className={`flex-1 bg-gradient-to-r ${currentSection.color} text-white px-8 py-4 rounded-xl hover:shadow-xl transform hover:scale-105 transition-all duration-300 flex items-center justify-center gap-3 disabled:opacity-70`}
                          >
                            {isLoading ? (
                              <>
                                <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                                <span>Downloading...</span>
                              </>
                            ) : (
                              <>
                                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                                  <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"/>
                                </svg>
                                <span className="font-semibold">Download Now</span>
                              </>
                            )}
                          </button>
                          
                          <button
                            onClick={closeModal}
                            className="flex-1 bg-white border-2 border-gray-300 text-gray-700 px-8 py-4 rounded-xl hover:bg-gray-50 hover:border-gray-400 transition-all duration-300 flex items-center justify-center gap-3"
                          >
                            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                            <span className="font-semibold">Cancel</span>
                          </button>
                        </div>
                        
                        <p className="text-center text-gray-500 text-sm mt-4">
                          This download is completely free. No registration required.
                        </p>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {/* Modal Footer */}
              <div className="bg-gray-50 p-6 border-t border-gray-100">
                <div className="flex items-center justify-center gap-2 text-gray-600">
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                  </svg>
                  <span>Secure viewing • No downloads required • Free forever</span>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default Books;